'use client';

import { ProductsReportModalView } from '@/components/products-report-modal/ProductsReportModalView';
import { useProductsReportModalController } from '@/components/products-report-modal/use-products-report-modal-controller';
import type { ActionButtonsActiveTable } from '@/components/action-buttons/action-buttons-view.types';
import { useAuth } from '@/context/auth.context';
import { useReviewsPageDataContext, useReviewsPageSelectionContext } from '@/context/reviews-page.context';

type ProductsReportModalProps = {
    isShown: boolean;
    setIsShown: (value: boolean) => void;
    activeTable: ActionButtonsActiveTable;
    summaryRefreshToken: number;
    isAiAnalysisLoading: boolean;
    isAiAnalysisDisabled: boolean;
    aiAnalysisDisabledReason: string | null;
    isAiAnalysisQuotaExhausted: boolean;
    onRunAiAnalysis: () => void;
    onOpenProducts: () => void;
    onOpenBrands: () => void;
};

const ProductsReportModal = ({
    isShown,
    setIsShown,
    activeTable,
    summaryRefreshToken,
    isAiAnalysisLoading,
    isAiAnalysisDisabled,
    aiAnalysisDisabledReason,
    isAiAnalysisQuotaExhausted,
    onRunAiAnalysis,
    onOpenProducts,
    onOpenBrands,
}: ProductsReportModalProps) => {
    const { products, brandGroups } = useReviewsPageDataContext();
    const { pickedReviews, pickedProducts, pickedBrandGroups } = useReviewsPageSelectionContext();
    const { accessToken } = useAuth();
    const controllerBindings = useProductsReportModalController({
        isShown,
        setIsShown,
        activeTable,
        accessToken,
        products,
        brandGroups,
        summaryRefreshToken,
        selectedReviewFeedItemIds: pickedReviews,
        selectedProductGroupIds: pickedProducts,
        selectedBrandGroupIds: pickedBrandGroups,
    });

    return (
        <ProductsReportModalView
            isShown={isShown}
            setIsShown={setIsShown}
            isAiAnalysisLoading={isAiAnalysisLoading}
            isAiAnalysisDisabled={isAiAnalysisDisabled}
            aiAnalysisDisabledReason={aiAnalysisDisabledReason}
            isAiAnalysisQuotaExhausted={isAiAnalysisQuotaExhausted}
            onRunAiAnalysis={onRunAiAnalysis}
            onOpenProducts={onOpenProducts}
            onOpenBrands={onOpenBrands}
            {...controllerBindings}
        />
    );
};

export default ProductsReportModal;
